import {Component, Input} from '@angular/core';
import {NgIf} from '@angular/common';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {v4 as uuidv4} from 'uuid';
import {IconsaxDirective} from '../../../directives/iconsax.directive';

@Component({
    selector: 'app-input-password',
    templateUrl: './input-password.component.html',
    styleUrls: ['./input-password.component.scss'],
    imports: [NgIf, ReactiveFormsModule, TranslateModule, IconsaxDirective]
})
export class InputPasswordComponent {
    @Input() name = uuidv4();
    @Input() id = uuidv4();
    @Input() labelName = '';
    @Input() placeholder?: any;
    @Input() submitted = false;
    @Input() readonly = false;
    @Input() group = new FormGroup({});
    @Input() control?: FormControl | undefined;
    @Input() controlName = '';
    @Input() tabindex?: number;
    @Input() invalid?: boolean;
    @Input() autocomplete = 'new-password';

    public isPasswordShow = false;

    get passwordControl(): FormControl {
        return this.control !== undefined ? this.control : this.group.get(this.controlName) as FormControl
    }

    get isRequired(): boolean {
        return this.passwordControl.hasValidator(Validators.required)
    }
}
